import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'polaris-components-quickstart.tasks.create-a-view.title',
		defaultMessage: 'Create a view',
		description: 'The title appears on the list of onboarding tasks in the sidebar',
	},
	description: {
		id: 'polaris-components-quickstart.tasks.create-a-view.description',
		defaultMessage:
			'Create and customize views to plan, prioritize, and roadmap for different audiences. Start with a board view for high-level planning.',
		description:
			'The description appears on the expanded task item of onboarding quickstart sidebar below the title',
	},
	roleRestrictionsText: {
		id: 'polaris-components-quickstart.tasks.create-a-view.role-restrictions-text',
		defaultMessage: "Contributors can't create views.",
		description: 'Text describing role restrictions',
	},
});
